export default {
  simplePlaceSearch: {
    'noPlaceFound': 'Nessun luogo trovato con queste indicazioni',
    'openSidebarToSeeRouteDetails': 'Apri la barra laterale per vedere i dettagli del percorso',
    'unknownSearchPlaceError': 'Errore sconosciuto durante la ricerca del luogo'
  }
}
